import { fromJS } from "immutable";

export default fromJS({
	inputs: {},
	bulkEditForm: null,
	bulkEditFormProps: null,
	bulkEditGroups: {
		showDueDateGroup: {
			isEditing: false,
			inputList: ["authorsDueDate", "signersDueDate"],
		},
		showVisibilityGroup: {
			isEditing: false,
			inputList: ["visible"],
		},
		showRedactAuthorGroup: {
			isEditing: false,
			inputList: ["redacted"],
		},
	},
	bulkEditInputs: {
		authorsDueDate: "",
		signersDueDate: "",
		visible: false,
		redacted: false,
	},
});
